import React from 'react';
import MeetingInformationButtonPicker from 'Views/Dashboard/MeetingInformationButtonPicker';
import { useNavigationDrawerContext } from 'Views/Onboarding/Contexts/NavigationDrawerContext';
import { FDBox, FDContentContainer, FDStack } from '@facet-wealth/design';
import useMobileLayout from 'Hooks/useMobileLayout';
import { useDashboardContext } from 'Views/Dashboard/DashboardContext';
import fr from 'facet-rest';
import ReviewItemsButton from 'Views/Dashboard/DefaultDesktopDashboardTopSection/ReviewItemsButton';
import { dataAttrs } from 'Helpers/Testing';

const DefaultDesktopDashboardTopSection = () => {
  const { handleShowNavigation } = useNavigationDrawerContext();
  const isMobile = useMobileLayout();
  const { clientDashboardResource } = useDashboardContext();

  const ReviewItemsButtonComponent = clientDashboardResource.withRelationship(fr.relationships.onboardingNavigation.name,
    () => <ReviewItemsButton onClick={handleShowNavigation} />,
    () => null);

  return (
    <FDStack direction={'column'} alignItems={'center'} justifyContent={'center'} width={'100%'}>
      <FDBox
        width={isMobile ? '100%' : 600}
        {...dataAttrs('dashboard-client-overview-section')}
      >
        <FDContentContainer maxWidth={'xs'}>
          <FDStack direction={'column'} spacing={2} alignItems="flex-start" justifyContent="flex-start">
            {ReviewItemsButtonComponent}
            <MeetingInformationButtonPicker />
          </FDStack>
        </FDContentContainer>
      </FDBox>
    </FDStack>
  );
};

DefaultDesktopDashboardTopSection.propTypes = {};

export default DefaultDesktopDashboardTopSection;
